<app-master-detail class="yf-master-detail" icon="person-outline" title="{{'PROFILE.PROFILE'|translate}}"
  [titleDetail]="titleDetail" [(show)]="masterDetailShow" filter="" (compactModeChange)="compactModeChange($event)"
  [forceCompact]="false">
  <div class="master">
    <div class="yf-md-container">
      <ion-list-header>
        <ion-label>{{ "PROFILE.USER" | translate }}</ion-label>
      </ion-list-header>
      <div class="m-6 pl-6 list-item">
        <ion-item button detail="true" (click)="showDetail(DetailTypes.User, DetailTitles.User)"
          [ngClass]="{ selected: detailType === DetailTypes.User}">
          <ion-avatar class="item-icon" slot="start">
            <img alt="Silhouette of a person's head" src="https://ionicframework.com/docs/img/demos/avatar.svg" />
          </ion-avatar>
          <ion-label>
            <h3 class="fw-600">{{ mainStateService.$user().name + ' ' + mainStateService.$user().surname }}</h3>
            <p>{{ mainStateService.$user().email }}</p>
          </ion-label>
        </ion-item>
      </div>

      <ion-list-header>
        <ion-label>{{ "PROFILE.SETTINGS" | translate }}</ion-label>
      </ion-list-header>
      <div class="m-6 pl-6 list-item">
        <ion-item button detail="true" (click)="showDetail(DetailTypes.Language, DetailTitles.Language)"
          [ngClass]="{ selected: detailType === DetailTypes.Language}">
          <ion-icon name="language-outline" class="item-icon" slot="start"></ion-icon>
          <ion-label>
            <h3 class="fw-600">{{ "PROFILE.LANGUAGE" | translate }}</h3>
            <p>{{ selectedLanguage === 'it' ? ('PROFILE.LANGUAGE_ITALIAN' | translate) : ('PROFILE.LANGUAGE_ENGLISH' | translate) }}</p>
          </ion-label>
        </ion-item>
      </div>
      <div class="m-6 pl-6 list-item">
        <ion-item button detail="true" (click)="openNotificationPreferences()">
          <ion-icon name="notifications-outline" class="item-icon" slot="start"></ion-icon>
          <ion-label>
            <h3 class="fw-600">{{ "NOTIF_PREFS.TITLE" | translate }}</h3>
            <p>{{ "NOTIF_PREFS.SUBTITLE" | translate }}</p>
          </ion-label>
        </ion-item>
      </div>

      @if (isAdmin) {
        <ion-list-header>
          <ion-label>{{ "PROFILE.ADMIN" | translate }}</ion-label>
        </ion-list-header>
        <div class="m-6 pl-6 list-item">
          <ion-item button detail="true" (click)="openImpersonate()">
            <ion-icon name="people-outline" class="item-icon" slot="start" color="warning"></ion-icon>
            <ion-label>
              <h3 class="fw-600">{{ "PROFILE.IMPERSONATE.TITLE" | translate }}</h3>
              <p>{{ "PROFILE.IMPERSONATE.SUBTITLE" | translate }}</p>
            </ion-label>
          </ion-item>
        </div>
      }

      <!-- VEICOLI -->
      <ion-list-header>
        <ion-label>{{ "PROFILE.CARS" | translate }}</ion-label>
      </ion-list-header>
      <!-- LISTA AUTO -->
      <div class="scroll-content">
        <ion-list>
          <div class="m-6 pl-6 list-item" *ngFor="let car of mainStateService.$userCars()">
            <ion-item button detail="true"
              [ngClass]="{ selected: (selectedCar$|async)?.id===car.id && detailType === DetailTypes.Car}">
              <ion-icon src="assets/app-icons/macchina.svg" class="item-icon" slot="start"></ion-icon>
              <ion-label (click)="showDetail(DetailTypes.Car, DetailTitles.Car, car)">
                <h3 class="fw-600">{{ car?.model?.brand?.name ? car.model.brand.name : '???'}}</h3>
                <p>{{ car?.model?.name ? car.model.name : '???' }}</p>
              </ion-label>
              <ion-icon [name]="car.isSelected? 'star':'star-outline'" class="item-car-icon pr-16"
                color="{{car.isSelected ? 'warning' : 'medium'}}" (click)="selectCar(car.id)"> </ion-icon>
            </ion-item>
          </div>
        </ion-list>
      </div>

      <!-- SPONSORSHIP -->
      @if (sponsorships.length) {
      <ion-list-header>
        <ion-label>{{ "PROFILE.SPONSORSHIPS" | translate }}</ion-label>
      </ion-list-header>
      <div class="scroll-content sponsorship-scroll">
        <ion-list>
          @for (sponsorship of sponsorships; track sponsorship.id || sponsorship.name) {
          <div class="m-6 pl-6 list-item">
            <ion-item button detail="true" (click)="showDetail(DetailTypes.Sponsorship, DetailTitles.Sponsorship, null, sponsorship)"
              [ngClass]="{ selected: selectedSponsorship === sponsorship && detailType === DetailTypes.Sponsorship}">
              <ion-icon name="ribbon-outline" class="item-icon" slot="start"></ion-icon>
              <ion-label>
                <h3 class="fw-600">{{ sponsorship.name }}</h3>
                <p>{{ sponsorship.companyName || ('PROFILE.SPONSORSHIP_PROGRAM' | translate) }}</p>
              </ion-label>
            </ion-item>
          </div>
          }
        </ion-list>
      </div>
      }


      <!-- VEICOLO DA AGGIUNGERE, SALVATO MOMENTANEAMENTE -->
      <ion-list-header *ngIf="savingNewCar">
        <ion-label>
          {{ "PROFILE.NEW_CAR" | translate }} <span style="color: grey" class="fw-500 fs-16">({{
            "PROFILE.NEW_CAR_NOT_SAVED" | translate }})</span>
        </ion-label>
      </ion-list-header>
      <div class="m-6 pl-6 list-item" *ngIf="!!savingNewCar"
        [ngClass]="{ selected: !selectedCar$ && detailType === DetailTypes.Car }">
        <ion-item button detail="true" (click)="showDetail(DetailTypes.Car, DetailTitles.Car, null)"
          [ngClass]="{ selected: !(selectedCar$ | async) && detailType === DetailTypes.Car }">
          <ion-icon src="assets/app-icons/macchina.svg" class="item-icon" slot="start"></ion-icon>
          <ion-label>
            <h3 class="fw-600">{{newVehicle?.model?.brand?.name ? newVehicle.model.brand.name : '???'}}</h3>
            <p>{{newVehicle?.model?.name ? newVehicle.model.name : '???'}}</p>
          </ion-label>
          <ion-icon name="create-outline" class="item-icon" color="secondary"> </ion-icon>
        </ion-item>
      </div>

    </div>

    <ion-footer class="ion-no-border yf-md-footer" *ngIf="!savingNewCar">
      <div>
        <ion-button class="btn large grow" color="primary" slot="end"
          (click)="showDetail(DetailTypes.Car, DetailTitles.Car, null)">{{ "PROFILE.ADD_NEW_CAR" | translate}}
          <!-- <ion-icon slot="start" src="assets/app-icons/aggiungi.svg"></ion-icon> -->
        </ion-button>
      </div>
    </ion-footer>
  </div>

  <div class="pl-6 detail">
    <div *ngIf="detailType === DetailTypes.User">
      <yf-user-edit> </yf-user-edit>
    </div>
    <div *ngIf="detailType === DetailTypes.Language">
      <ion-list lines="full">
        <ion-list-header>
          <ion-label>{{ 'PROFILE.LANGUAGE' | translate }}</ion-label>
        </ion-list-header>
        <ion-item>
          <ion-icon name="language-outline" slot="start" color="primary"></ion-icon>
          <ion-select [label]="'PROFILE.LANGUAGE_SELECT' | translate" labelPlacement="stacked"
            interface="popover" [ngModel]="selectedLanguage" (ngModelChange)="changeLanguage($event)">
            @for (language of languageOptions; track language.value) {
            <ion-select-option [value]="language.value">
              {{ language.labelKey | translate }}
            </ion-select-option>
            }
          </ion-select>
        </ion-item>
      </ion-list>
    </div>
    <div *ngIf="detailType === DetailTypes.NotificationPreferences">
      <app-notification-preferences-detail></app-notification-preferences-detail>
    </div>
    <div *ngIf="detailType === DetailTypes.Car">
      <yf-car-edit [car$]="selectedCar$" [savingNewCar]="savingNewCar" (cancelEvent)="handleCancelEvent($event)"
        (deleteEvent)="handleDeleteEvent()" (formChanges)="handleFormChanges($event)"></yf-car-edit>
    </div>
    @if (detailType === DetailTypes.Sponsorship) {
    <div class="sponsorship-detail">
      @if (selectedSponsorship) {
        <ion-list lines="full">
          <ion-item>
            <ion-icon name="ribbon-outline" slot="start" color="primary"></ion-icon>
            <ion-label>
              <h2>{{ selectedSponsorship.name }}</h2>
              <p>{{ selectedSponsorship.companyName || ('PROFILE.SPONSORSHIP_PROGRAM' | translate) }}</p>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="information-circle-outline" slot="start" color="medium"></ion-icon>
            <ion-label class="ion-text-wrap">
              <p>{{ 'PROFILE.SPONSORSHIP_ACTIVE_INFO' | translate }}</p>
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-label>
              <p>{{ 'PROFILE.SPONSORSHIP_INCLUDED_BY' | translate }}</p>
              <h3>
                @if (selectedSponsorship.appliesToGroupName || selectedSponsorship.appliesToGroupId) {
                  {{ selectedSponsorship.appliesToGroupName || ('#' + selectedSponsorship.appliesToGroupId) }}
                } @else {
                  {{ 'PROFILE.SPONSORSHIP_INCLUDED_ALL' | translate }}
                }
              </h3>
            </ion-label>
          </ion-item>

          @if (selectedSponsorship.validFrom || selectedSponsorship.validTo) {
          <ion-item>
            <ion-label>
              <p>{{ 'PROFILE.SPONSORSHIP_VALIDITY' | translate }}</p>
              <h3>{{ formatPolicyDate(selectedSponsorship.validFrom) }} - {{ formatPolicyDate(selectedSponsorship.validTo) }}</h3>
            </ion-label>
          </ion-item>
          }

          <ion-item>
            <ion-icon name="time-outline" slot="start" color="primary"></ion-icon>
            <ion-label class="ion-text-wrap">
              <p>{{ 'PROFILE.SPONSORSHIP_TIME_WINDOWS' | translate }}</p>
              @if (hasActivationRules(selectedSponsorship)) {
                @for (rule of (selectedSponsorship.activationRules || []); track rule.id || $index) {
                  <h3>{{ activationRuleText(rule) }}</h3>
                  @if (activationRuleTimezone(rule)) {
                    <p>{{ 'PROFILE.SPONSORSHIP_TIMEZONE' | translate: { timezone: activationRuleTimezone(rule) } }}</p>
                  }
                  @if (rule.notes) {
                    <p>{{ rule.notes }}</p>
                  }
                }
              } @else {
                <h3>{{ 'PROFILE.SPONSORSHIP_ALWAYS_ACTIVE' | translate }}</h3>
              }
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-icon name="cash-outline" slot="start" color="primary"></ion-icon>
            <ion-label class="ion-text-wrap">
              <p>{{ 'PROFILE.SPONSORSHIP_COVERAGE_TITLE' | translate }}</p>
              @if (hasCoverageRules(selectedSponsorship)) {
                @for (rule of selectedSponsorship.coverageRules; track rule.id || rule.componentType || $index) {
                  <h3>{{ coverageRuleText(rule) }}</h3>
                }
              } @else {
                <h3>{{ 'PROFILE.SPONSORSHIP_NO_COVERAGE_RULES' | translate }}</h3>
              }
            </ion-label>
          </ion-item>

          @if (selectedSponsorship.coverageRuleLimits?.length) {
          <ion-item>
            <ion-label>
              <p>{{ 'PROFILE.SPONSORSHIP_LIMITS' | translate }}</p>
              <h3>{{ 'PROFILE.SPONSORSHIP_LIMITS_ACTIVE' | translate }}</h3>
            </ion-label>
          </ion-item>
          }

          @if (selectedSponsorship.notes) {
          <ion-item>
            <ion-label>
              <p>{{ 'PROFILE.SPONSORSHIP_NOTES' | translate }}</p>
              <h3>{{ selectedSponsorship.notes }}</h3>
            </ion-label>
          </ion-item>
          }
        </ion-list>
      } @else {
        <div class="empty-detail">
          <ion-icon name="ribbon-outline"></ion-icon>
          <p>{{ 'PROFILE.NO_SPONSORSHIPS' | translate }}</p>
        </div>
      }
    </div>
    }
  </div>
</app-master-detail>
